"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BrandStoneDark = exports.BrandStoneBase = exports.BrandStoneLight = exports.BrandForestDark = exports.BrandForestBase = exports.BrandForestLight = exports.BrandFlushText = exports.BrandFlushDark = exports.BrandFlushBase = exports.BrandFlushLight = exports.BrandOceanText = exports.BrandOceanDark = exports.BrandOceanBase = exports.BrandOceanLight = exports.BrandLemonDark = exports.BrandLemonBase = exports.BrandLemonLight = exports.BrandSkyText = exports.BrandSkyDark = exports.BrandSkyBase = exports.BrandSkyLight = exports.BrandRedDark = exports.BrandRedBase = exports.BorderFocus = exports.BorderSecondary = exports.BorderPrimary = exports.SystemBlue100 = exports.SystemBlue90 = exports.SystemBlue80 = exports.SystemBlue70 = exports.SystemBlue60 = exports.SystemBlue50 = exports.SystemBlue40 = exports.SystemBlue30 = exports.SystemBlue20 = exports.SystemBlue10 = exports.SystemBlue5 = exports.SystemBlue0 = exports.SystemTeal100 = exports.SystemTeal90 = exports.SystemTeal80 = exports.SystemTeal70 = exports.SystemTeal60 = exports.SystemTeal50 = exports.SystemTeal40 = exports.SystemTeal30 = exports.SystemTeal20 = exports.SystemTeal10 = exports.SystemTeal5 = exports.SystemTeal0 = exports.SystemGreen100 = exports.SystemGreen90 = exports.SystemGreen80 = exports.SystemGreen70 = exports.SystemGreen60 = exports.SystemGreen50 = exports.SystemGreen40 = exports.SystemGreen30 = exports.SystemGreen20 = exports.SystemGreen10 = exports.SystemGreen5 = exports.SystemGreen0 = exports.SystemYellow100 = exports.SystemYellow90 = exports.SystemYellow80 = exports.SystemYellow70 = exports.SystemYellow60 = exports.SystemYellow50 = exports.SystemYellow40 = exports.SystemYellow30 = exports.SystemYellow20 = exports.SystemYellow10 = exports.SystemYellow5 = exports.SystemYellow0 = exports.SystemRed100 = exports.SystemRed90 = exports.SystemRed80 = exports.SystemRed70 = exports.SystemRed60 = exports.SystemRed50 = exports.SystemRed40 = exports.SystemRed30 = exports.SystemRed20 = exports.SystemRed10 = exports.SystemRed5 = exports.SystemRed0 = exports.SystemGrey100 = exports.SystemGrey90 = exports.SystemGrey80 = exports.SystemGrey70 = exports.SystemGrey60 = exports.SystemGrey50 = exports.SystemGrey40 = exports.SystemGrey30 = exports.SystemGrey20 = exports.SystemGrey10 = exports.SystemGrey5 = exports.SystemGrey0 = exports.SystemBlack = exports.SystemWhite = void 0;
exports.WarningText = exports.WarningBackground = exports.WarningForeground = exports.TextLink = exports.TextHighlight = exports.TextWarning = exports.TextError = exports.TextSelected = exports.TextAction = exports.TextTertiary = exports.TextSecondary = exports.TextPrimary = exports.SelectedText = exports.SelectedBackground = exports.SelectedForeground = exports.PageBackgroundTertiary = exports.PageBackgroundSecondary = exports.PageBackgroundPrimary = exports.ErrorText = exports.ErrorBackground = exports.ErrorForeground = exports.ButtonFlatSecondaryPressed = exports.ButtonFlatSecondaryHovered = exports.ButtonFlatSecondary = exports.ButtonFlatPrimaryPressed = exports.ButtonFlatPrimaryHovered = exports.ButtonFlatPrimary = exports.ButtonTertiaryToggleBorderOn = exports.ButtonTertiaryToggleBorderOff = exports.ButtonTertiaryToggleBackgroundOff = exports.ButtonTertiaryForegroundDisabled = exports.ButtonTertiaryForeground = exports.ButtonTertiaryBackgroundDisabled = exports.ButtonTertiaryBackgroundPressed = exports.ButtonTertiaryBackgroundHovered = exports.ButtonTertiaryBackground = exports.ButtonSecondaryToggleBorderOn = exports.ButtonSecondaryToggleBorderOff = exports.ButtonSecondaryToggleBackgroundOff = exports.ButtonSecondaryForegroundDisabled = exports.ButtonSecondaryForeground = exports.ButtonSecondaryBackgroundDisabled = exports.ButtonSecondaryBackgroundPressed = exports.ButtonSecondaryBackgroundHovered = exports.ButtonSecondaryBackground = exports.ButtonPrimaryToggleBorderOn = exports.ButtonPrimaryToggleBorderOff = exports.ButtonPrimaryToggleBackgroundOff = exports.ButtonPrimaryForegroundDisabled = exports.ButtonPrimaryForeground = exports.ButtonPrimaryBackgroundDisabled = exports.ButtonPrimaryBackgroundPressed = exports.ButtonPrimaryBackgroundHovered = exports.ButtonPrimaryBackground = void 0;
// GENERATED FILE, PLEASE DO NOT EDIT
var SystemWhite = '#ffffff';
exports.SystemWhite = SystemWhite;
var SystemBlack = '#191919';
exports.SystemBlack = SystemBlack;
var SystemGrey0 = '#f7f7f7';
exports.SystemGrey0 = SystemGrey0;
var SystemGrey5 = '#e7e7e7';
exports.SystemGrey5 = SystemGrey5;
var SystemGrey10 = '#d6d6d6';
exports.SystemGrey10 = SystemGrey10;
var SystemGrey20 = '#c4c4c4';
exports.SystemGrey20 = SystemGrey20;
var SystemGrey30 = '#b2b2b2';
exports.SystemGrey30 = SystemGrey30;
var SystemGrey40 = '#9f9f9f';
exports.SystemGrey40 = SystemGrey40;
var SystemGrey50 = '#8b8b8b';
exports.SystemGrey50 = SystemGrey50;
var SystemGrey60 = '#767676';
exports.SystemGrey60 = SystemGrey60;
var SystemGrey70 = '#606060';
exports.SystemGrey70 = SystemGrey70;
var SystemGrey80 = '#494949';
exports.SystemGrey80 = SystemGrey80;
var SystemGrey90 = '#313131';
exports.SystemGrey90 = SystemGrey90;
var SystemGrey100 = '#191919';
exports.SystemGrey100 = SystemGrey100;
var SystemRed0 = '#fff7f5';
exports.SystemRed0 = SystemRed0;
var SystemRed5 = '#fff0ed';
exports.SystemRed5 = SystemRed5;
var SystemRed10 = '#ffe0db';
exports.SystemRed10 = SystemRed10;
var SystemRed20 = '#fec7bd';
exports.SystemRed20 = SystemRed20;
var SystemRed30 = '#fda294';
exports.SystemRed30 = SystemRed30;
var SystemRed40 = '#fa7463';
exports.SystemRed40 = SystemRed40;
var SystemRed50 = '#f54323';
exports.SystemRed50 = SystemRed50;
var SystemRed60 = '#eb1700';
exports.SystemRed60 = SystemRed60;
var SystemRed70 = '#d91400';
exports.SystemRed70 = SystemRed70;
var SystemRed80 = '#b71000';
exports.SystemRed80 = SystemRed80;
var SystemRed90 = '#810b00';
exports.SystemRed90 = SystemRed90;
var SystemRed100 = '#380500';
exports.SystemRed100 = SystemRed100;
var SystemYellow0 = '#ffffeb';
exports.SystemYellow0 = SystemYellow0;
var SystemYellow5 = '#ffffa3';
exports.SystemYellow5 = SystemYellow5;
var SystemYellow10 = '#feff58';
exports.SystemYellow10 = SystemYellow10;
var SystemYellow20 = '#f6e61b';
exports.SystemYellow20 = SystemYellow20;
var SystemYellow30 = '#e8c500';
exports.SystemYellow30 = SystemYellow30;
var SystemYellow40 = '#d5a600';
exports.SystemYellow40 = SystemYellow40;
var SystemYellow50 = '#bd8800';
exports.SystemYellow50 = SystemYellow50;
var SystemYellow60 = '#a16c00';
exports.SystemYellow60 = SystemYellow60;
var SystemYellow70 = '#835200';
exports.SystemYellow70 = SystemYellow70;
var SystemYellow80 = '#835200';
exports.SystemYellow80 = SystemYellow80;
var SystemYellow90 = '#452700';
exports.SystemYellow90 = SystemYellow90;
var SystemYellow100 = '#261500';
exports.SystemYellow100 = SystemYellow100;
var SystemGreen0 = '#f6fffa';
exports.SystemGreen0 = SystemGreen0;
var SystemGreen5 = '#e7fbef';
exports.SystemGreen5 = SystemGreen5;
var SystemGreen10 = '#cef4dd';
exports.SystemGreen10 = SystemGreen10;
var SystemGreen20 = '#a9e9c1';
exports.SystemGreen20 = SystemGreen20;
var SystemGreen30 = '#7bd89d';
exports.SystemGreen30 = SystemGreen30;
var SystemGreen40 = '#4bc275';
exports.SystemGreen40 = SystemGreen40;
var SystemGreen50 = '#1fa74f';
exports.SystemGreen50 = SystemGreen50;
var SystemGreen60 = '#00872f';
exports.SystemGreen60 = SystemGreen60;
var SystemGreen70 = '#006a25';
exports.SystemGreen70 = SystemGreen70;
var SystemGreen80 = '#004c1b';
exports.SystemGreen80 = SystemGreen80;
var SystemGreen90 = '#002f10';
exports.SystemGreen90 = SystemGreen90;
var SystemGreen100 = '#001206';
exports.SystemGreen100 = SystemGreen100;
var SystemTeal0 = '#f5ffff';
exports.SystemTeal0 = SystemTeal0;
var SystemTeal5 = '#ecfcfc';
exports.SystemTeal5 = SystemTeal5;
var SystemTeal10 = '#d7f5f5';
exports.SystemTeal10 = SystemTeal10;
var SystemTeal20 = '#b6e9ea';
exports.SystemTeal20 = SystemTeal20;
var SystemTeal30 = '#8bd8da';
exports.SystemTeal30 = SystemTeal30;
var SystemTeal40 = '#5bc1c4';
exports.SystemTeal40 = SystemTeal40;
var SystemTeal50 = '#2aa4a9';
exports.SystemTeal50 = SystemTeal50;
var SystemTeal60 = '#00838a';
exports.SystemTeal60 = SystemTeal60;
var SystemTeal70 = '#00666d';
exports.SystemTeal70 = SystemTeal70;
var SystemTeal80 = '#00494e';
exports.SystemTeal80 = SystemTeal80;
var SystemTeal90 = '#002c2f';
exports.SystemTeal90 = SystemTeal90;
var SystemTeal100 = '#001012';
exports.SystemTeal100 = SystemTeal100;
var SystemBlue0 = '#fafbff';
exports.SystemBlue0 = SystemBlue0;
var SystemBlue5 = '#f4f6fe';
exports.SystemBlue5 = SystemBlue5;
var SystemBlue10 = '#e6ebfd';
exports.SystemBlue10 = SystemBlue10;
var SystemBlue20 = '#d1dafb';
exports.SystemBlue20 = SystemBlue20;
var SystemBlue30 = '#b4c2fa';
exports.SystemBlue30 = SystemBlue30;
var SystemBlue40 = '#91a5f9';
exports.SystemBlue40 = SystemBlue40;
var SystemBlue50 = '#6c87fb';
exports.SystemBlue50 = SystemBlue50;
var SystemBlue60 = '#4969f5';
exports.SystemBlue60 = SystemBlue60;
var SystemBlue70 = '#2a4de4';
exports.SystemBlue70 = SystemBlue70;
var SystemBlue80 = '#1537c7';
exports.SystemBlue80 = SystemBlue80;
var SystemBlue90 = '#082496';
exports.SystemBlue90 = SystemBlue90;
var SystemBlue100 = '#02124f';
exports.SystemBlue100 = SystemBlue100;
var BorderPrimary = SystemGrey5;
exports.BorderPrimary = BorderPrimary;
var BorderSecondary = SystemGrey10;
exports.BorderSecondary = BorderSecondary;
var BorderFocus = SystemBlue30;
exports.BorderFocus = BorderFocus;
var BrandRedBase = '#ff3008';
exports.BrandRedBase = BrandRedBase;
var BrandRedDark = '#de3725';
exports.BrandRedDark = BrandRedDark;
var BrandSkyLight = '#e1f6fa';
exports.BrandSkyLight = BrandSkyLight;
var BrandSkyBase = '#d1f0f6';
exports.BrandSkyBase = BrandSkyBase;
var BrandSkyDark = '#bedfe9';
exports.BrandSkyDark = BrandSkyDark;
var BrandSkyText = '#24809c';
exports.BrandSkyText = BrandSkyText;
var BrandLemonLight = '#fcf89a';
exports.BrandLemonLight = BrandLemonLight;
var BrandLemonBase = '#faf258';
exports.BrandLemonBase = BrandLemonBase;
var BrandLemonDark = '#f8e500';
exports.BrandLemonDark = BrandLemonDark;
var BrandOceanLight = '#73a3a6';
exports.BrandOceanLight = BrandOceanLight;
var BrandOceanBase = '#518c8f';
exports.BrandOceanBase = BrandOceanBase;
var BrandOceanDark = '#3a646e';
exports.BrandOceanDark = BrandOceanDark;
var BrandOceanText = SystemTeal60;
exports.BrandOceanText = BrandOceanText;
var BrandFlushLight = '#fae4e1';
exports.BrandFlushLight = BrandFlushLight;
var BrandFlushBase = '#f3d1cd';
exports.BrandFlushBase = BrandFlushBase;
var BrandFlushDark = '#e5bbb7';
exports.BrandFlushDark = BrandFlushDark;
var BrandFlushText = '#ce483b';
exports.BrandFlushText = BrandFlushText;
var BrandForestLight = '#61786d';
exports.BrandForestLight = BrandForestLight;
var BrandForestBase = '#3a5648';
exports.BrandForestBase = BrandForestBase;
var BrandForestDark = '#28362c';
exports.BrandForestDark = BrandForestDark;
var BrandStoneLight = '#e6e5d8';
exports.BrandStoneLight = BrandStoneLight;
var BrandStoneBase = '#c6c5b6';
exports.BrandStoneBase = BrandStoneBase;
var BrandStoneDark = '#666666';
exports.BrandStoneDark = BrandStoneDark;
var ButtonPrimaryBackground = SystemRed60;
exports.ButtonPrimaryBackground = ButtonPrimaryBackground;
var ButtonPrimaryBackgroundHovered = SystemRed70;
exports.ButtonPrimaryBackgroundHovered = ButtonPrimaryBackgroundHovered;
var ButtonPrimaryBackgroundPressed = SystemRed80;
exports.ButtonPrimaryBackgroundPressed = ButtonPrimaryBackgroundPressed;
var ButtonPrimaryBackgroundDisabled = SystemRed20;
exports.ButtonPrimaryBackgroundDisabled = ButtonPrimaryBackgroundDisabled;
var ButtonPrimaryForeground = SystemWhite;
exports.ButtonPrimaryForeground = ButtonPrimaryForeground;
var ButtonPrimaryForegroundDisabled = SystemWhite;
exports.ButtonPrimaryForegroundDisabled = ButtonPrimaryForegroundDisabled;
var ButtonPrimaryToggleBackgroundOff = SystemWhite;
exports.ButtonPrimaryToggleBackgroundOff = ButtonPrimaryToggleBackgroundOff;
var ButtonPrimaryToggleBorderOff = SystemGrey10;
exports.ButtonPrimaryToggleBorderOff = ButtonPrimaryToggleBorderOff;
var ButtonPrimaryToggleBorderOn = SystemRed90;
exports.ButtonPrimaryToggleBorderOn = ButtonPrimaryToggleBorderOn;
var ButtonSecondaryBackground = SystemRed5;
exports.ButtonSecondaryBackground = ButtonSecondaryBackground;
var ButtonSecondaryBackgroundHovered = SystemRed10;
exports.ButtonSecondaryBackgroundHovered = ButtonSecondaryBackgroundHovered;
var ButtonSecondaryBackgroundPressed = SystemRed20;
exports.ButtonSecondaryBackgroundPressed = ButtonSecondaryBackgroundPressed;
var ButtonSecondaryBackgroundDisabled = SystemRed5;
exports.ButtonSecondaryBackgroundDisabled = ButtonSecondaryBackgroundDisabled;
var ButtonSecondaryForeground = SystemRed70;
exports.ButtonSecondaryForeground = ButtonSecondaryForeground;
var ButtonSecondaryForegroundDisabled = SystemRed20;
exports.ButtonSecondaryForegroundDisabled = ButtonSecondaryForegroundDisabled;
var ButtonSecondaryToggleBackgroundOff = SystemWhite;
exports.ButtonSecondaryToggleBackgroundOff = ButtonSecondaryToggleBackgroundOff;
var ButtonSecondaryToggleBorderOff = SystemGrey10;
exports.ButtonSecondaryToggleBorderOff = ButtonSecondaryToggleBorderOff;
var ButtonSecondaryToggleBorderOn = SystemRed30;
exports.ButtonSecondaryToggleBorderOn = ButtonSecondaryToggleBorderOn;
var ButtonTertiaryBackground = SystemGrey5;
exports.ButtonTertiaryBackground = ButtonTertiaryBackground;
var ButtonTertiaryBackgroundHovered = SystemGrey10;
exports.ButtonTertiaryBackgroundHovered = ButtonTertiaryBackgroundHovered;
var ButtonTertiaryBackgroundPressed = SystemGrey20;
exports.ButtonTertiaryBackgroundPressed = ButtonTertiaryBackgroundPressed;
var ButtonTertiaryBackgroundDisabled = SystemGrey0;
exports.ButtonTertiaryBackgroundDisabled = ButtonTertiaryBackgroundDisabled;
var ButtonTertiaryForeground = SystemGrey100;
exports.ButtonTertiaryForeground = ButtonTertiaryForeground;
var ButtonTertiaryForegroundDisabled = SystemGrey30;
exports.ButtonTertiaryForegroundDisabled = ButtonTertiaryForegroundDisabled;
var ButtonTertiaryToggleBackgroundOff = SystemWhite;
exports.ButtonTertiaryToggleBackgroundOff = ButtonTertiaryToggleBackgroundOff;
var ButtonTertiaryToggleBorderOff = SystemGrey10;
exports.ButtonTertiaryToggleBorderOff = ButtonTertiaryToggleBorderOff;
var ButtonTertiaryToggleBorderOn = SystemGrey40;
exports.ButtonTertiaryToggleBorderOn = ButtonTertiaryToggleBorderOn;
var ButtonFlatPrimary = SystemRed60;
exports.ButtonFlatPrimary = ButtonFlatPrimary;
var ButtonFlatPrimaryHovered = SystemRed70;
exports.ButtonFlatPrimaryHovered = ButtonFlatPrimaryHovered;
var ButtonFlatPrimaryPressed = SystemRed80;
exports.ButtonFlatPrimaryPressed = ButtonFlatPrimaryPressed;
var ButtonFlatSecondary = SystemGrey80;
exports.ButtonFlatSecondary = ButtonFlatSecondary;
var ButtonFlatSecondaryHovered = SystemGrey90;
exports.ButtonFlatSecondaryHovered = ButtonFlatSecondaryHovered;
var ButtonFlatSecondaryPressed = SystemGrey100;
exports.ButtonFlatSecondaryPressed = ButtonFlatSecondaryPressed;
var ErrorForeground = SystemWhite;
exports.ErrorForeground = ErrorForeground;
var ErrorBackground = SystemRed80;
exports.ErrorBackground = ErrorBackground;
var ErrorText = SystemRed80;
exports.ErrorText = ErrorText;
var PageBackgroundPrimary = SystemWhite;
exports.PageBackgroundPrimary = PageBackgroundPrimary;
var PageBackgroundSecondary = SystemGrey0;
exports.PageBackgroundSecondary = PageBackgroundSecondary;
var PageBackgroundTertiary = SystemGrey5;
exports.PageBackgroundTertiary = PageBackgroundTertiary;
var SelectedForeground = SystemRed70;
exports.SelectedForeground = SelectedForeground;
var SelectedBackground = SystemRed5;
exports.SelectedBackground = SelectedBackground;
var SelectedText = SystemRed60;
exports.SelectedText = SelectedText;
var TextPrimary = SystemGrey100;
exports.TextPrimary = TextPrimary;
var TextSecondary = SystemGrey80;
exports.TextSecondary = TextSecondary;
var TextTertiary = SystemGrey60;
exports.TextTertiary = TextTertiary;
var TextAction = SystemRed60;
exports.TextAction = TextAction;
var TextSelected = SystemRed60;
exports.TextSelected = TextSelected;
var TextError = SystemRed80;
exports.TextError = TextError;
var TextWarning = SystemYellow60;
exports.TextWarning = TextWarning;
var TextHighlight = SystemTeal60;
exports.TextHighlight = TextHighlight;
var TextLink = SystemTeal60;
exports.TextLink = TextLink;
var WarningForeground = SystemGrey100;
exports.WarningForeground = WarningForeground;
var WarningBackground = SystemYellow10;
exports.WarningBackground = WarningBackground;
var WarningText = SystemYellow60;
exports.WarningText = WarningText;